<template>
  <div class="p-6">
    <div
      v-if="success"
      class="mb-4 max-w-2xl mx-auto p-4 bg-emerald-50 border border-emerald-200 rounded-xl text-emerald-800 flex items-center gap-2"
    >
      <svg class="w-5 h-5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      Usage log recorded successfully! Redirecting...
    </div>
    <div
      v-if="error"
      class="mb-4 max-w-2xl mx-auto p-4 bg-red-50 border border-red-200 rounded-xl text-red-800"
    >
      {{ error }}
    </div>

    <UsageLogForm
      :is-open="true"
      :loading="loading"
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useUsageStore } from '@/stores/usageStore'
import type { UsageLogCreate } from '@/types/usage'
import UsageLogForm from '@/components/usage/UsageLogForm.vue'
import { useRouter } from 'vue-router'

const usageStore = useUsageStore()
const loading = ref(false)
const success = ref(false)
const error = ref('')
const router = useRouter()

const handleSave = async (data: UsageLogCreate) => {
  loading.value = true
  error.value = ''
  success.value = false
  try {
    await usageStore.createUsageLog(data)
    success.value = true
    setTimeout(() => {
      router.push({ name: 'UsageView' })
    }, 1200)
  } catch (err: unknown) {
    const e = err as unknown as Error
    error.value = e?.message || 'Failed to create usage log.'
  } finally {
    loading.value = false
  }
}

const handleCancel = () => {
  router.push({ name: 'UsageView' })
}
</script>
